import { useSelector, useDispatch } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { removePage } from "../store/state/pagehistory";

const Tabs = () => {
  const pageHistory = useSelector((state) => state.history.pageHistory);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

const handleRemovePage = (page) => {
  const currentIndex = pageHistory.findIndex(p => 
    p.url === page.url && JSON.stringify(p.state) === JSON.stringify(page.state)
  );

  const isCurrentPage = (
    location.pathname === page.url && 
    JSON.stringify(location.state) === JSON.stringify(page.state)
  );

  dispatch(removePage({
    url: page.url,
    state: page.state
  }));

  if (isCurrentPage) {
    if (pageHistory.length > 1) {
      let pageToNavigate;
      
      if (currentIndex === pageHistory.length - 1) {
        pageToNavigate = pageHistory[currentIndex - 1];
      } 
      else if (currentIndex < pageHistory.length - 1) {
        pageToNavigate = pageHistory[currentIndex + 1];
      } 
      else {
        pageToNavigate = pageHistory[currentIndex - 1];
      }

      navigate(pageToNavigate.url, { state: pageToNavigate.state });
    } else {
      navigate("/dashboard/");
    }
  }
};

  return (
    <div className="chrome-tabs-container" style={{ display: pageHistory.length > 0 ? "flex" : "none",overflow:'hidden' }}>
      <div className="tabs" style={{ paddingLeft: "2px",position:'relative',bottom:'-1px' }}>
        {pageHistory.map((page, index) => {
          const isActive = (
            location.pathname === page.url && 
            JSON.stringify(location.state) === JSON.stringify(page.state)
          );
          
          return (
            <div
              key={index}
              style={{ padding: "4px 10px" }}
              className={`tab ${isActive ? "active" : ""}`}
            >
              <div className={` show-tab-custom ${isActive ? "text-light" : "w-100"}`}
                onClick={ () => navigate(page.url,{ state: page.state})}
              >
                {page.name}
              </div>
              {/* <Link 
                to={page.url} 
                state={page.state}
                style={{ padding: "4px 10px" }}
                className="show-tab-custom"
              >
                {page.name}
              </Link> */}
              
              <button
                onClick={() => handleRemovePage(page)}
                className="remove-tab-custom"
              >
                &times;
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Tabs;